<template>
  <el-dialog
    ref="dialog"
    class="ui-dialog-wrapper"
    :visible="value"
    :append-to-body="appendToBody"
    :close-on-click-modal="closeOnClickModal"
    :custom-class="resolvedCustomClass"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @update:visible="updateVisible"
    @opened="resetDirtyState"
    @closed="resetDirtyState"
  >
    <slot />
    <template v-if="$slots.title || $scopedSlots.title || $attrs.title" slot="title">
      <slot name="title">
        <span class="el-dialog__title ui-section-title" :class="{ 'has-icon': Boolean(icon) }">
          <i v-if="icon" :class="icon" aria-hidden="true"></i>{{ $t($attrs.title) }}</span>
      </slot>
    </template>
    <template v-if="$slots.footer" slot="footer"><slot name="footer" /></template>
  </el-dialog>
</template>

<script>
import { resetFormDirtyAura } from '@/utils/formDirtyAura'

export default {
  name: 'UiDialog',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    icon: { type: [String, Array, Object], default: '' },
    appendToBody: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: true },
    customClass: { type: String, default: '' }
  },
  computed: {
    resolvedCustomClass () {
      return ['ui-dialog', this.customClass].filter(Boolean).join(' ')
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners['update:visible']
      return listeners
    }
  },
  methods: {
    updateVisible (visible) {
      this.$emit('input', visible)
      this.$emit('update:visible', visible)
    },
    resetDirtyState () {
      this.$nextTick(() => {
        const wrapper = this.$refs.dialog && this.$refs.dialog.$el
        resetFormDirtyAura(wrapper && wrapper.querySelector('.el-dialog'))
      })
    }
  }
}
</script>
